module.exports = __webpack_public_path__ + "img/timeanswer.77d7b596.png";